const endpoints = {
    user: 'user',
    userGiveBC: 'user/give-bc',
    userTransactions: (userId: string) => `user/${userId}/transactions`,
}

export default endpoints
